module.exports = "/assets/data/42cc22da0b127136099b7b870581a85b-L69.data.json";